import { Button } from '@/components/ui/button'
import { CheckCircle2, MessageCircle } from 'lucide-react'
import heroImage from '@/assets/image-788e8.png'

export const HeroSection = () => {
  const whatsappUrl =
    'https://wa.me/5511963087549?text=Quero%20saber%20mais%20sobre%20o%20SuperFut%20Kids'

  return (
    <section className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden bg-gradient-to-b from-blue-50 to-white">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="grid gap-12 lg:grid-cols-2 items-center">
          <div className="space-y-8 animate-fade-in-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-super-text leading-tight">
              Futebol divertido e educativo para crianças de{' '}
              <span className="text-super-green">2 a 7 anos</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-[600px]">
              Aulas individuais e em grupo na região de Moema a Alto de
              Pinheiros (SP).
            </p>

            <ul className="space-y-3">
              {[
                'Metodologia lúdica e segura',
                'Professores com experiência com pequenos',
                'Evolução motora, social e confiança',
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="h-6 w-6 text-super-green flex-shrink-0" />
                  <span className="text-base font-medium text-slate-700">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                size="lg"
                className="bg-super-yellow text-super-text hover:bg-yellow-400 text-lg font-bold px-8 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                asChild
              >
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Quero saber mais
                </a>
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="text-super-blue border-super-blue hover:bg-blue-50 text-lg font-semibold px-8 rounded-full"
                asChild
              >
                <a href="#map">Ver área de atendimento</a>
              </Button>
            </div>
          </div>

          <div className="relative animate-fade-in lg:block">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-all duration-500">
              <img
                src={heroImage}
                alt="Criança jogando futebol feliz"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
            </div>
            {/* Decor elements */}
            <div className="absolute -z-10 -bottom-10 -right-10 w-32 h-32 bg-super-yellow/30 rounded-full blur-3xl" />
            <div className="absolute -z-10 -top-10 -left-10 w-40 h-40 bg-super-green/20 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>
  )
}
